import { render, staticRenderFns } from "./T1KierunkiModal.vue?vue&type=template&id=49f5f105&scoped=true&"
import script from "./T1KierunkiModal.vue?vue&type=script&lang=js&"
export * from "./T1KierunkiModal.vue?vue&type=script&lang=js&"
import style0 from "./T1KierunkiModal.vue?vue&type=style&index=0&id=49f5f105&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f5f105",
  null
  
)

export default component.exports